import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MaterialsQaqcService } from '../../../services/materials-qaqc.service';
import { MaterialsQaqcGroupDto } from '@models/materials-qaqc-dto.interface';

@Component({
  selector: 'app-materials-qaqc',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './materials-qaqc.component.html',
  styleUrl: './materials-qaqc.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialsQaqcComponent implements OnChanges {
  @Input() jobId: number | null = null;

  private readonly materialsQaqcService = inject(MaterialsQaqcService);

  protected groups = signal<MaterialsQaqcGroupDto[] | null>(null);
  protected isLoading = signal(false);
  protected errorMessage = signal<string | null>(null);

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['jobId']) return;

    // Parent reuses this component instance across job navigations, so reset immediately
    // to avoid flashing the previous job's rows while the new job loads.
    this.groups.set(null);
    this.errorMessage.set(null);

    if (this.jobId && this.jobId > 0) {
      this.loadData(this.jobId);
    }
  }

  private loadData(jobId: number): void {
    this.isLoading.set(true);
    this.materialsQaqcService.getMaterialsQaqc(jobId).subscribe({
      next: (groups) => {
        this.groups.set(groups);
        this.isLoading.set(false);
      },
      error: () => {
        this.errorMessage.set('Failed to load materials QAQC data.');
        this.isLoading.set(false);
      }
    });
  }
}
